<template>
    <div>
        <div class="mt-5 text-center">
            กำลัง Login Line
        </div>

        <ModalMaster :controller="modalController"></ModalMaster>
    </div>
</template>
<script>
//Util
import Account from '@/helper/AccountHelper.js';
import Util from '@/helper/Utility.js';
import LineFunction from '@/helper/facade/LineFunction.js';
import BzbsAuth from '@/core/Account/service/BzbsAuth.js';
//mixin
import ModalMixin from "@/mixin/ModalMixin.js";

export default {
    name: 'LoginLine',
    mixins: [ModalMixin],
    data: function() {
        return {
            liffId: null,
        };
    },
    created: function() {
        this.initLiff();
    },
    mounted: function() {
    },
    methods: {
        initLiff: function() {
            var lineFunction = new LineFunction();
            this.liffId = lineFunction.getLiffId();

            lineFunction.init(this.liffId).then(() => {

                var currentUrl = window.location.href;
                if (lineFunction.isLogin()) {
                    if (lineFunction.isTokenExpire()) {
                        lineFunction.logout();
                        lineFunction.login(currentUrl);
                        return;
                    }

                    var idToken = lineFunction.getIdToken();

                    if (idToken != null) {
                        this.loginBzbs(idToken);
                    } else {
                        // alert('Something error');
                        this.$router.replace('/error');
                    }
                } else {
                    lineFunction.login(currentUrl);
                }
            }).catch((err) => {
                console.log(err);
                this.$router.replace('/error');
            });
        },
        loginBzbs: async function(idToken) {
            var success = await this.apiLoginLine(idToken);

            if (success) {
                this.redirectLogin();
            } else {
                this.redirectNotLogin();
            }
        },
        apiLoginLine: async function(idToken) {
            return new Promise((resolve) => {
                BzbsAuth.apiLoginLine(idToken).subscribe((data) => {
                    Account.setLogin(data);
                    resolve(true);
                }, (err) => {
                    console.log(err);
                    // window.location.replace('/termandcondition');
                    resolve(false);
                });
            });
        },

        redirectNotLogin: function() {
            let targetPage = this.$route.query.target_page;
            if (!Util.isEmptyStr(targetPage) && targetPage.indexOf('getfrined') > -1) {
                //% /register/getfrined/{refcode}
                window.location.replace('/' + targetPage);
            } else {
                window.location.replace('/termandcondition');
            }
        },
        redirectLogin: function() {
            var targetPage = this.$route.query.target_page;
            if (Util.isEmptyStr(targetPage)) {
                targetPage = '';
            }
            window.location.replace("/" + targetPage);
        },
    },
}
</script>
